// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas_wrapper {
  margin-top: 20px;
  margin-bottom: 10px;
  border: 1px solid rgba(186, 165, 153, 0.4);
  border-radius: 3px;
  padding: 10px;
}
.canvas_wrapper .center_spinner {
  margin-bottom: 100px;
}
.canvas_wrapper .controller {
  background: #baa599;
  color: #fef9f2;
  border-radius: 30px;
  opacity: 0.6;
}
.canvas_wrapper .controller ul {
  display: inline-flex;
  justify-content: space-evenly;
  text-align: center;
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 7px 0;
}
.canvas_wrapper .controller ul li {
  font-size: 14px;
  text-transform: uppercase;
  padding: 6px 16px;
  border-radius: 30px;
  cursor: pointer;
}
.canvas_wrapper .controller ul li ion-icon {
  margin-top: 2px;
}
.canvas_wrapper .controller ul .selected {
  background: #948176;
  font-weight: bold;
}
.canvas_wrapper .pale_brick {
  margin-top: -37px;
  opacity: 0.5;
}
.canvas_wrapper .pale_brick h3 {
  font-size: 10px;
  text-align: center;
  width: 60%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15%;
  color: #baa599;
  font-weight: 800;
}
.canvas_wrapper .extraInfo {
  margin: 0;
  font-size: 9px;
  text-align: left;
  margin-left: 3px;
  margin-bottom: 20px;
  margin-top: 12px;
  font-weight: bold;
  color: #bba599;
  width: 100%;
  text-align: center;
}
.canvas_wrapper .canvas_elem {
  position: relative;
  height: 10vh;
  width: 40vw;
}

.gradedNote {
  font-size: 12px;
  text-align: left;
  width: 90%;
  display: block;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #baa599;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pricing-charts/pricing-charts.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;AACJ;AACI;EACI,oBAAA;AACR;AAEI;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAEQ;EACI,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;AAAZ;AAEY;EACI,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAAhB;AAEgB;EACI,eAAA;AAApB;AAIY;EACI,mBAAA;EACA,iBAAA;AAFhB;AAOI;EACI,iBAAA;EACA,YAAA;AALR;AAOQ;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AALZ;AASI;EACI,SAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAPR;AAUI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AARR;;AAYA;EACI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AATJ","sourcesContent":[".canvas_wrapper {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    border: 1px solid #baa59966;\n    border-radius: 3px;\n    padding: 10px;\n\n    .center_spinner {\n        margin-bottom: 100px;\n    }\n\n    .controller {\n        background: #baa599;\n        color: #fef9f2;\n        border-radius: 30px;\n        opacity: 0.6;\n\n        ul {\n            display: inline-flex;\n            justify-content: space-evenly;\n            text-align: center;\n            list-style: none;\n            width: 100%;\n            padding: 0;\n            margin: 7px 0;\n\n            li {\n                font-size: 14px;\n                text-transform: uppercase;\n                padding: 6px 16px;\n                border-radius: 30px;\n                cursor: pointer;\n\n                ion-icon {\n                    margin-top: 2px;\n                }\n            }\n\n            .selected {\n                background: #948176;\n                font-weight: bold;\n            }\n        }\n    }\n\n    .pale_brick {\n        margin-top: -37px;\n        opacity: 0.5;\n\n        h3 {\n            font-size: 10px;\n            text-align: center;\n            width: 60%;\n            display: block;\n            margin-left: auto;\n            margin-right: auto;\n            margin-top: 15%;\n            color: #baa599;\n            font-weight: 800;\n        }\n    }\n\n    .extraInfo {\n        margin: 0;\n        font-size: 9px;\n        text-align: left;\n        margin-left: 3px;\n        margin-bottom: 20px;\n        margin-top: 12px;\n        font-weight: bold;\n        color: #bba599;\n        width: 100%;\n        text-align: center;\n    }\n\n    .canvas_elem {\n        position: relative;\n        height: 10vh;\n        width: 40vw;\n    }\n}\n\n.gradedNote {\n    font-size: 12px;\n    text-align: left;\n    width: 90%;\n    display: block;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    color: #baa599;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
